import Vue from 'vue/dist/vue.esm.js'
import Select2MultiMixin from '../mixins/select2_multi_mixin.js.coffee'

KCVS.Views.ReportsIndexView = Vue.extend(
  mounted: ->
    if @selectedPeriod && !@selectedPeriod.is_open
      @setPeriodClosedAlarm()

  data: ->
    periodsCollection: [] # Passed in on initialization
    selectedPeriodIds: [] # Passed in on initialization
    projectPartnerReportPeriods: [] # Passed in on initialization
    generateRowsLink: ''# Passed in on initialization
    xlsDownloadLinkTemplate: '' # Passed in on initialization
    iceboxXlsDownloadLinkTemplate: '' # Passed in on initialization
    alertClass: null
    alert: null
    loading: false

  computed:
    sortedProjectPartnerReportPeriods: ->
      _.sortBy @projectPartnerReportPeriods, (pprp) ->
        parseInt(pprp.project_number)

    periodIdsParams: ->
      $.param({ report_period_ids: @resolvedPeriodIds })

    xlsDownloadLink: ->
      "#{@xlsDownloadLinkTemplate}?#{@periodIdsParams}"

    iceboxXlsDownloadLink: ->
      "#{@iceboxXlsDownloadLinkTemplate}?#{@periodIdsParams}"

    periodsSelection: ->
      options = _.map @periodsCollection, (period) -> [period.name, period.id]
      [[I18n.t('admin.reports.index.all_periods'), 'all']].concat(options)

    allPeriodsSelected: ->
      @selectedPeriodIds.indexOf('all') > -1

    selectedPeriod: ->
      return null if @multiplePeriodsSelected || @selectedPeriodIds.length == 0
      selectedId = parseInt(@selectedPeriodIds[0])
      _.filter(@periodsCollection, (period) => period.id == selectedId)[0]

    multiplePeriodsSelected: ->
      @allPeriodsSelected || @selectedPeriodIds.length > 1

    resolvedPeriodIds: ->
      if @allPeriodsSelected
        _.map(@periodsCollection, (period) -> period.id)
      else
        @selectedPeriodIds

    rowAutoNumberingAllowed: ->
      @selectedPeriod && @selectedPeriod.row_auto_numbering_allowed

    singleOpenPeriodSelected: ->
      @selectedPeriod && @selectedPeriod.is_open

    hasPeriodsSelected: ->
      @selectedPeriodIds.length > 0

  watch:
    selectedPeriodIds: (newVal, oldVal) ->
      if @allPeriodsSelected && newVal.length > 1
        hadAllOnly = oldVal && oldVal.length == 1 && oldVal[0] == 'all'
        cleaned = if hadAllOnly then _.without(newVal, 'all') else ['all']
        @selectedPeriodIds = cleaned
        $('#period_select').val(cleaned).trigger('change.select2')
        return

      if @selectedPeriod && !@selectedPeriod.is_open
        @setPeriodClosedAlarm()
      else
        @clearAlert()

      @getProjectPartnerReportPeriods()

  methods:
    onPeriodSelect: (val) ->
      return if _.isEqual(val, @selectedPeriodIds)
      @selectedPeriodIds = val || []

    setPeriodClosedAlarm: ->
      @alert = I18n.t('admin.reports.index.period_closed')
      @alertClass = 'alert-warning'

    getProjectPartnerReportPeriods: ->
      return unless @hasPeriodsSelected
      $.ajax
        dataType: 'JSON'
        data: @periodIdsParams
        url: '/admin/project_partner_report_periods'
        beforeSend: =>
          @loading = true
        success: (data) =>
          @projectPartnerReportPeriods = data
          @loading = false
        error: (data) =>
          @alert = data.responseJSON.message
          @alertClass = 'alert-danger'
          @loading = false

    initializeRowGeneration: (e) ->
      return if @multiplePeriodsSelected

      $.ajax
        dataType: 'JSON'
        data:
          report_period_id: @selectedPeriodIds[0]
        url: @generateRowsLink
        success: (data) =>
          @alert = data.message
          @alertClass = 'alert-success'
        error: (data) =>
          @alert = data.responseJSON.message
          @alertClass = 'alert-danger'

    toggleRowAutoNumbering: ->
      return if @multiplePeriodsSelected

      unless @rowAutoNumberingAllowed
        return unless confirm(I18n.t('admin.reports.index.auto_row_renumbering_unlock_warning'))
      $.ajax
        dataType: 'JSON'
        method: 'PUT'
        data:
          report_period:
            row_auto_numbering_allowed: !@rowAutoNumberingAllowed
        url: "/admin/report_periods/#{@selectedPeriodIds[0]}/toggle_row_auto_numbering_allowed"
        success: (data) =>
          @selectedPeriod.row_auto_numbering_allowed = !@rowAutoNumberingAllowed
        error: (data) =>
          @alert = data.responseJSON.message
          @alertClass = 'alert-danger'

    closePeriod: ->
      @togglePeriodState
        url: @selectedPeriod.close_period_path
        confirmMessage: I18n.t('admin.reports.index.period_closing_warning')
        errorMessage: I18n.t('notices.report_periods.problem_closing')
        onSuccess: =>
          @selectedPeriod.is_open = false
          @setPeriodClosedAlarm()

    openPeriod: ->
      @togglePeriodState
        url: @selectedPeriod.close_period_path.replace('close', 'open')
        confirmMessage: I18n.t('admin.reports.index.period_opening_warning')
        errorMessage: I18n.t('notices.report_periods.problem_opening')
        onSuccess: =>
          @selectedPeriod.is_open = true
          @clearAlert()

    togglePeriodState: ({ url, confirmMessage, errorMessage, onSuccess }) ->
      return if @multiplePeriodsSelected
      return unless confirm(confirmMessage)

      $.ajax
        dataType: 'JSON'
        method: 'PUT'
        url: url
        data: { authenticity_token: $('meta[name="csrf-token"]').attr('content') }
        success: =>
          onSuccess()
          @getProjectPartnerReportPeriods()
        error: (data) =>
          @alert = data.responseJSON?.message || errorMessage
          @alertClass = 'alert-danger'

    clearAlert: ->
      @alert = null
      @alertClass = ''

  components:
    periodSelect: Select2MultiMixin
)
